import { RequestValidationEventDetail } from "../../../../types/EventDetailTypes"
import { assertIsCustomEvent } from "../../helpers/assertIsCustomEvent"

/**
 * @memberof useValidateSchema
 * */
export const getFieldNamesToValidate = (event: CustomEvent<RequestValidationEventDetail>) => {
    assertIsCustomEvent(event)
    const detail = event.detail

    const fields: string[] = [detail?.fieldName]

    if (typeof detail?.relatedFields === 'string') {
        fields.push(detail?.relatedFields)
    }
    if (Array.isArray(detail?.relatedFields)) {
        fields.push(...detail?.relatedFields)
    }
    return [...(new Set(fields))]
}

